interface HeartbeatIconProps {
  active?: boolean;
  disabled?: boolean;
  size?: number;
  className?: string;
}

export default function HeartbeatIcon({ active = true, disabled = false, size = 16, className }: HeartbeatIconProps) {
  const height = size / 2;
  return (
    <svg
      className={`heartbeat-icon${active && !disabled ? ' heartbeat-icon-active' : ' heartbeat-icon-inactive'}${disabled ? ' heartbeat-icon-disabled' : ''}${className ? ` ${className}` : ''}`}
      viewBox="0 0 24 12"
      width={size}
      height={height}
      aria-hidden="true"
    >
      <polyline
        points="0,6 4,6 6,2 8,10 10,4 12,8 14,6 24,6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
